import { c as _c } from "react/compiler-runtime";
import ActiveUserPlanColumn from 'modules/profile/user-plan/components/price-plan-columns/components/active-user-plan-column';
import UserPlanColumn from 'modules/profile/user-plan/components/price-plan-columns/components/user-plan-column';
import { BillingPeriodEnum } from 'modules/profile/user-plan/enums/billing-period-enum';
import { UseUserPlanInterface } from 'modules/profile/user-plan/types/user-plan-interface';
import { getBillingPeriodFromSubscriptionPeriod, isUserPlanActive } from 'modules/profile/user-plan/utils/price-plan-utils';
import React from 'react';
import { twMerge } from 'tailwind-merge';
export interface PricePlanColumnsProps {
  currentUserPlanData: UseUserPlanInterface;
  billingPeriod: BillingPeriodEnum;
}
const getPricePlanColumnKey = (pricePlan: UseUserPlanInterface['userPlans'][number]) => {
  const priceInterval = pricePlan.price?.interval ?? 'without-price';
  return `${pricePlan.id}-${priceInterval}`;
};
const getVisibleUserPlans = (userPlans: UseUserPlanInterface['userPlans'], billingPeriod: BillingPeriodEnum) => userPlans.filter(pricePlan => {
  if (!pricePlan.price) {
    return pricePlan.currentUserPlan;
  }
  return getBillingPeriodFromSubscriptionPeriod(pricePlan.price.interval) === billingPeriod;
});
const PricePlanColumns = t0 => {
  const $ = _c(15);
  const {
    currentUserPlanData,
    billingPeriod
  } = t0;
  let t1;
  let t2;
  if ($[0] !== billingPeriod || $[1] !== currentUserPlanData.customer?.paymentMethod || $[2] !== currentUserPlanData.userPlans || $[3] !== currentUserPlanData.userResources) {
    const visibleUserPlans = getVisibleUserPlans(currentUserPlanData.userPlans, billingPeriod);
    const shouldUseFourColumnLayout = visibleUserPlans.length === 4;
    const t3 = shouldUseFourColumnLayout ? "desktop:grid-cols-[repeat(4,1fr)]" : "desktop:grid-cols-[repeat(3,1fr)]";
    if ($[6] !== t3) {
      t1 = twMerge("desktop:grid", t3, "flex w-full snap-both snap-mandatory flex-row items-center gap-6 overflow-x-scroll overflow-y-hidden scroll-smooth px-2 pt-10 desktop:overflow-hidden desktop:px-6");
      $[6] = t3;
      $[7] = t1;
    } else {
      t1 = $[7];
    }
    let t4;
    if ($[8] !== billingPeriod || $[9] !== currentUserPlanData.customer?.paymentMethod || $[10] !== currentUserPlanData.userResources) {
      t4 = pricePlan => isUserPlanActive(pricePlan, billingPeriod) ? <ActiveUserPlanColumn pricePlan={pricePlan} billingPeriod={billingPeriod} userRecourses={currentUserPlanData.userResources} key={getPricePlanColumnKey(pricePlan)} /> : <UserPlanColumn pricePlan={pricePlan} billingPeriod={billingPeriod} key={getPricePlanColumnKey(pricePlan)} isPlanUpgradeAvailable={pricePlan.upgradeAvailable} paymentMethod={currentUserPlanData.customer?.paymentMethod} />;
      $[8] = billingPeriod;
      $[9] = currentUserPlanData.customer?.paymentMethod;
      $[10] = currentUserPlanData.userResources;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t2 = visibleUserPlans.map(t4);
    $[0] = billingPeriod;
    $[1] = currentUserPlanData.customer?.paymentMethod;
    $[2] = currentUserPlanData.userPlans;
    $[3] = currentUserPlanData.userResources;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  let t3;
  if ($[12] !== t1 || $[13] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default PricePlanColumns;